import React from 'react';
import { IconProps } from '../types/types';

const ZKTOKEN: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><g clipPath="url(#a)"><circle cx="10" cy="10" r="10" fill="#fff"/><path d="m4.444 9.903 3.237-3.236v1.618h3.237l-3.237 2.428v2.427L4.444 9.903ZM15.773 9.903l-3.236 3.237v-1.618H9.3l3.237-2.428V6.667l3.236 3.236Z" fill="#000"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
);

export default ZKTOKEN;
